import { Component } from '@angular/core';
import { NbTokenService } from '@nebular/auth';
import { NbDialogService } from '@nebular/theme';
import { EditStationComponent } from './stations/edit-station/edit-station.component';
import { DetailStationComponent } from './stations/detail-station/detail-station.component';
import { Router } from '@angular/router';
import {MessagingService} from '../../services/messaging.service';
const moment = require('moment');
const Lockr = require("lockr");

@Component({
  selector: 'ngx-splasboard',
  templateUrl: './splasboard.component.html',
  styleUrls: ['./splasboard.component.scss'],
})
export class SplasboardComponent {
  moment = moment;
  procedure: string = '';
  state: string = 'Noticias';
  station: any;
  stationId: string;
  events: Array<any> = [];
  notifications = [];
  showPanel: boolean = false;
  accountId: string = '';
  isSuperAdmin: boolean = false;
  message;
  loading = false;
  user: {
    email: '',
    name: '',
  };
  completeSignature = false;
  completeFisrtStation = false;

  constructor(
    private messagingService: MessagingService,
    private dialog: NbDialogService,
    protected tokenService: NbTokenService,
    public router: Router,
  ) { }

  // tslint:disable-next-line: use-lifecycle-interface
  async ngOnInit() {
    this.loading = true;
    await this.getUserData();

    const user = Lockr.get('user');
    if (user.account) {
      this.accountId = user.account;
    } else {
      this.accountId = user.user_id;
      this.isSuperAdmin = true;
    }

    let data = Lockr.get('initialData');
    this.completeSignature = !data.signature;
    this.completeFisrtStation = !data.firstStationExists;

    this.loading = false;
  }

  onChangeTab(event) {
    const previousState = this.state;
    this.state = event.tabTitle;
    if (this.state === 'Cursos') {
      window.open('https://grupoproessa.neolms.com/', '_blank');
      this.state = previousState;
    }
    this.setProcedure(event.tabTitle.toLowerCase());
  }

  setProcedure(procedure) {
    this.procedure = procedure;
  }

  loadNotifications(userId: string) {
    this.messagingService.getNotificationsFirestore(userId).subscribe((notificationsSnapshot) => {
      this.notifications = [];
      notificationsSnapshot.forEach((notification: any) => {
        this.notifications.push({
          id: notification.payload.doc.id,
          ...notification.payload.doc.data(),
        });
      });
    });
  }

  editStation(station) {
    this.dialog.open(EditStationComponent, {
      hasScroll: true,
      context: {
        station: station,
      },
    });
  }

  detailStation(station) {
    this.dialog.open(DetailStationComponent, {
      hasScroll: true,
      context: {
        station: station,
      },
    });
  }

  refreshStation() {
    const tempState = this.state;
    this.state = '';
    setTimeout(_ => this.state = tempState, 500);
  }

  showPanelEvent(value) {
    if (value) this.showPanel = true;
  }

  async getUserData() {
    this.user = Lockr.get('user');
  }

  async changeStatusNotification(notification: any) {
    // if (notification.state && notification.state !== '') this.state = notification.state;
    const [err] = await this.messagingService.changeStatusReadNotification(notification.id);
    if (err) return console.error(err);
    this.notifications = this.notifications.filter(notificationAux => notificationAux.id !== notification.id);
  }

  logout() {
    this.tokenService.clear();
    localStorage.clear();
    this.router.navigate(['auth/login']);
  }

  goToProfile() {
    this.router.navigate(['/pages/profile']);
  }
}
